import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="navbar">
      <div className="navbar__inner">
        <Link to="/" className="navbar__brand">
          <span className="brand-main">Giuseppe's</span>
          <span className="brand-sub">Ristorante</span>
        </Link>

        <button
          className={`navbar__burger ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span /><span /><span />
        </button>

        <ul className={`navbar__links ${menuOpen ? 'open' : ''}`}>
          {[
            { path: '/', label: 'Home' },
            { path: '/about', label: 'About' },
            { path: '/menu', label: 'Menu' },
            { path: '/gallery', label: 'Gallery' },
            { path: '/contact', label: 'Contact' },
          ].map(({ path, label }) => (
            <li key={path}>
              <Link to={path} className={`navbar__link ${isActive(path) ? 'active' : ''}`}>
                {label}
              </Link>
            </li>
          ))}
          <li>
            <a href="tel:5869484900" className="navbar__phone">
              586-948-4900
            </a>
          </li>
          <li>
            <a href="https://order.yourmenu.com/giuseppesristorante" target="_blank" rel="noopener noreferrer" className="navbar__order">
              Order Now
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
}
